import { PCRoutes } from './routerPC';
import { mobileRoutes } from './routerMobile';

import { getCookie } from "utils/cookie";
import Vue from "vue";
import VueRouter from "vue-router";
import { qrCode } from './qrCode'

Vue.use(VueRouter);

const routesP = PCRoutes
const routesM = mobileRoutes


//定义一个函数判断是手机端还是pc端
function isMobile() {
  if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    // console.log("移动端");
    return true; // 移动端
  } else {
    // console.log("PC端");
    return false; // PC端
  }
}

console.log(routesP, 'routesProutesP')

const routesData = isMobile() ? routesM : routesP
console.log(routesData, 'routesDataroutesDataroutesData')
var routes = [
  {
    path: '/',
    component: () => import('../layout/index.vue'),
    children: [
      ...routesP,
      ...routesM,

    ]
  },
];


console.log(routes, 'routes')

const createRouter = () =>
  new VueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    // scrollBehavior: () => ({ y: 0 }),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
        return {
          selector: to.hash,
        };
      }
    },
  });

const qr_code = qrCode;

const hash = window.location.hash.split("?")[1];
console.log(hash);

const router = createRouter();
router.beforeEach((to, from, next) => {
  console.log("to.path: ", to, to.path);
  console.log(isMobile(), 'isMobile00000')

  if (to.path.startsWith("/c/")) {
    // 路由格式：“https://kubuqiaward.com/#/c/:id”
    let id = to.path.slice(3); // 获取id
    let redirectUrl = qr_code[id]; // 从map中获取重定向链接
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    } else {
      next("/");
    }

  } else {
    console.log(getCookie("token"), 'getCookie')
    if (getCookie("token")) {
      if (to.path.startsWith("/mobile/") && to.name == 'mobileLogin') {
        console.log('mobileLogin')
        next({ path: '/mobile/home' })
      } else {

        next();
      }
    } else {
      next();
    }
    // chrome
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    // safari
    window.pageYOffset = 0;
  }
});

router.afterEach((to, from) => {
  console.log(to, from, 'to, from')
  console.log(isMobile(), 'isMobile11111')
  console.log(sessionStorage.getItem('currentPath'), 'localStorage.getItem')
  const locaPath = sessionStorage.getItem('currentPath')
  if (!locaPath) {
    const path = isMobile() ? '/mobile/home' : '/pc/home'
    sessionStorage.setItem('currentPath', path);
  } else {
    sessionStorage.setItem('currentPath', to.fullPath);
  }
});
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}

export default router;
